import React, { useState, useEffect } from "react"

import { MenuItem, Button, Snackbar } from "@material-ui/core"
import { ExpandMore } from "@material-ui/icons"

import Container from "../../ui/Container"

import Menu from "../../ui/Menu"
import PageTitle from "../../ui/PageTitle"
import ProductCard from "../../ui/ProductCard"

const sortString = {
  "descending": {
    "ua": "За ціною (спочатку дорожчі)",
    "ru": "За ценой (сначала дороже)",
  },
  "ascending": {
    "ua": "За ціною (спочатку дешевші)",
    "ru": "За ценой (сначала дешевле)"
  },
  "alphabetical": {
    "ua": "За назвою",
    "ru": "По названию"
  }
}

const CollectionBlock = ({ collection, translation, sort, setSort }) => {
  const [products, setProducts] = useState(collection.products)
  const { filters, category } = collection

  useEffect(() => {
    setProducts(collection.products)
  }, [collection])

  const [filterIndex, setFilterIndex] = useState(-1)
  const [menuAnchor, setMenuAnchor] = useState(null)
  const [filterAnchor, setFilterAnchor] = useState(null)
  const [snackBarOpen, setSnackBarOpen] = useState(false)

  const applySort = s => {
    setSort(s)
    setMenuAnchor(null)
  }

  const applyFilter = index => {
    setFilterIndex(index)
    setFilterAnchor(null)
  }

  const getProducts = () => {
    if (filterIndex === -1) {
      return (
        <div className="Collection--items">
          {products.map(product => (
            <ProductCard
              key={product.id}
              translation={translation}
              product={product}
              onBuy={() => setSnackBarOpen(true)}
            />
          ))}
        </div>
      )
    } else {
      let filtered = []
      if (filters.length !== 0) {
        filtered = products.filter(
          product => product.filter === filters[filterIndex].id
        )
      }

      if (filtered.length !== 0) {
        return (
          <div className="Collection--items">
            {filtered.map(product => (
              <ProductCard
                key={product.id}
                translation={translation}
                product={product}
                onBuy={() => setSnackBarOpen(true)}
              />
            ))}
          </div>
        )
      } else {
        return (
          <div className="Collection--empty">
            <p>
              {translation.language === "ua"
                ? "Жоден товар не відповідає заданому фільтру"
                : "Ни один товар не соотвествует заданному фильтру"}
            </p>
            <Button variant="outlined" color="primary" onClick={() => applyFilter(-1)}>
              {translation.language === "ua" ? "Показати всі" : "Показать все"}
            </Button>
          </div>
        )
      }
    }
  }

  return (
    <div id={category.url} className="Collection--category">
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        open={snackBarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackBarOpen(false)}
        message="Товар добавлено в корзину"
      />
      <PageTitle
        title={translation.translateKey(category, "name")}
        subtitle={translation.translateKey(category, "short")}
      />
      <Container>
        <div className="Collection--category--actions">
          <div className="Collection--category--action Collection--category--sort">
            <span className="Collection--category--filter--name" id="collection-sort-label">
              {translation.language === "ua" && "Сортування"}
              {translation.language === "ru" && "Сортировка"}
            </span>
            <Button
              variant="outlined"
              onClick={e => setMenuAnchor(e.currentTarget)}
              endIcon={<ExpandMore />}
              aria-haspopup="true"
              aria-expanded={Boolean(menuAnchor)}
              aria-describedby="collection-sort-label"
              className="Collection--select"
            >
              {sortString[sort][translation.language]}
            </Button>
            <Menu
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={() => setMenuAnchor(null)}
            >
              <MenuItem selected={sort === "descending"} onClick={() => applySort("descending")}>
                {sortString["descending"][translation.language]}
              </MenuItem>
              <MenuItem selected={sort === "ascending"} onClick={() => applySort("ascending")}>
                {sortString["ascending"][translation.language]}
              </MenuItem>
              <MenuItem selected={sort === "alphabetical"} onClick={() => applySort("alphabetical")}>
                {sortString["alphabetical"][translation.language]}
              </MenuItem>
            </Menu>
          </div>
          <div className="Collection--category--action Collection--category--filter">
            {filters.length !== 0 && (
              <>
                <span className="Collection--category--filter--name" id="collection-filter-label">
                  {translation.language === "ua" && "Фільтр"}
                  {translation.language === "ru" && "Фильтр"}
                </span>
                <Button
                  variant="outlined"
                  onClick={e => setFilterAnchor(e.currentTarget)}
                  endIcon={<ExpandMore />}
                  aria-haspopup="true"
                  aria-expanded={Boolean(filterAnchor)}
                  aria-describedby="collection-filter-label"
                  className={`Collection--select${filterIndex !== -1 ? " active" : ""}`}
                >
                  {filterIndex !== -1 &&
                    translation.translateKey(filters[filterIndex], "name")}
                  {filterIndex === -1
                    ? translation.language === "ua"
                      ? "Всі"
                      : "Все"
                    : null}
                </Button>
              </>
            )}
            <Menu
              anchorEl={filterAnchor}
              open={Boolean(filterAnchor)}
              onClose={() => setFilterAnchor(null)}
            >
              <MenuItem
                selected={filterIndex === -1}
                onClick={() => {
                  applyFilter(-1)
                }}
              >
                {translation.language === "ua" ? "Всі" : "Все"}
              </MenuItem>
              {filters.map((filter, index) => {
                return (
                  <MenuItem
                    key={filter.id}
                    selected={filterIndex === index}
                    onClick={() => {
                      applyFilter(index)
                    }}
                  >
                    {translation.translateKey(filter, "name")}
                  </MenuItem>
                )
              })}
            </Menu>
          </div>
        </div>
        {getProducts()}
      </Container>
    </div>
  )
}

export default CollectionBlock
